import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-text-primary py-10 px-4" data-id="element-28">
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-6" data-id="element-29">
        <a href="https://www.instagram.com/velara_7/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-secondary hover:text-primary transition-colors" data-id="element-30">
          <Instagram className="w-5 h-5" data-id="element-31" />
          <span className="text-sm font-medium" data-id="element-32">@velara_7</span>
        </a>

        <p className="text-secondary/70 text-sm" data-id="element-33">
          © 2026 Guía Ciclo Consciente. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}